import RouterModel from "@/router/RouterModel.js";
import AppModule from "@/services/App/AppModule.js";
import AppModuleType from "@/services/App/AppModuleType.js";

import HppAdjDetails from "./Details/HppAdjDetails";
import HppAdjList from "./List/HppAdjList";
import HppAdjNew from "./New/HppAdjNew";
import HppAdjPrintDetails from "./PrintDetails/HppAdjPrintDetails";

export default {
  Path: {
    Details: RouterModel.getPath(AppModule.HppAdj, AppModuleType.Details),
    List: RouterModel.getPath(AppModule.HppAdj, AppModuleType.List),
    New: RouterModel.getPath(AppModule.HppAdj, AppModuleType.New),
    PrintDetails: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintDetails)
  },

  Item: {
    List: RouterModel.getPath(AppModule.Item, AppModuleType.List)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.Details),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.Details),
        component: HppAdjDetails,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.Details),
          moduleName: RouterModel.getModule(AppModule.HppAdj)
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.List),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.List),
        component: HppAdjList,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.List),
          moduleName: RouterModel.getModule(AppModule.HppAdj)
        }
      },
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.New),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.New),
        component: HppAdjNew,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.New),
          moduleName: RouterModel.getModule(AppModule.HppAdj)
        }
      },
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.HppAdj, AppModuleType.PrintDetails),
        name: RouterModel.getName(AppModule.HppAdj, AppModuleType.PrintDetails),
        component: HppAdjPrintDetails,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.HppAdj, AppModuleType.PrintDetails),
          moduleName: RouterModel.getModule(AppModule.HppAdj)
        }
      }
    ];
  }
}